import { z } from 'zod';

export const emailSchema = z.email().max(255).nullable();

export const nameSchema = z.string().trim().max(255);

export const reasonSchema = z.string().trim().max(255);

export const versionSchema = z
    .string()
    .trim()
    .refine(value => ['1.0.1', '1.0.2', '1.0.4'].includes(value));

// Pattern from user-administration-service: @Pattern(regexp = "^|\\+[1-9][0-9]{5,13}$")
export const phoneSchema = z.preprocess(
    value => (typeof value === 'string' ? value.replace(/ /g, '') : value),
    z
        .string()
        .regex(/^\+[1-9][0-9]{5,13}$/, 'Phone number must have form +89123456.')
        .min(7) // = 5 + 2 (matching the min number of characters from user-admin-service regex)
        .max(15) // = 13 + 2 (matching the max number of characters from user-admin-service regex)
);
